import { apiClient } from './api/client';
import { UserPreference, CreateUserPreferenceDto, UpdateUserPreferenceDto } from '@/types/users';

const API_BASE = '/user-preferences';

export const userPreferencesService = {
  async get(): Promise<UserPreference | null> {
    try {
      const response = await apiClient.get<UserPreference>(API_BASE);
      return response.data ?? null;
    } catch (err: any) {
      // Mantém o comportamento antigo: 404 => null
      if (err?.response?.status === 404) return null;
      throw err;
    }
  },

  async create(data: CreateUserPreferenceDto): Promise<UserPreference> {
    const response = await apiClient.post<UserPreference>(API_BASE, data);
    return response.data;
  },

  async update(data: UpdateUserPreferenceDto): Promise<UserPreference> {
    const response = await apiClient.patch<UserPreference>(API_BASE, data);
    return response.data;
  },
};